/**
 * 导游
 * */
export default {
    namespaced: true,
    state: {
        history: [], // 浏览记录
        keyword: [], // 搜索记录
        user: {}
    },
    actions: {
        /**
         * @description 设置查看的浏览记录
         * @param {Object} state vuex state
         * @param {Object} dispatch vuex dispatch
         * @param {*} info info
         */
        setHistory ({ state, dispatch }, info) {
            return new Promise(async resolve => {
                // store 赋值
                state.history = info;
                let oldInfo = await dispatch('db/get', {
                  dbName: 'database',
                  path: 'guideHistory',
                  defaultValue: {}
              }, { root: true });
              let userInfo = await dispatch('db/get', {
                  dbName: 'database',
                  path: 'userInfo',
                  defaultValue: {}
              }, { root: true });
              if (userInfo.mobile) {
                  oldInfo[userInfo.mobile] = info
              } else {
                  oldInfo.all = info
              }
                // 持久化
                await dispatch('db/set', {
                    dbName: 'database',
                    path: 'guideHistory',
                    value: oldInfo
                }, { root: true });
                // end
                resolve();
            })
        },

        /**
         * @description 从数据库取查看的浏览记录
         * @param {Object} state vuex state
         * @param {Object} dispatch vuex dispatch
         */
        loadHistory ({ state, dispatch }) {
            return new Promise(async resolve => {
                // store 赋值
                let oldInfo = await dispatch('db/get', {
                    dbName: 'database',
                    path: 'guideHistory',
                    defaultValue: {}
                }, { root: true });
                let userInfo = await dispatch('db/get', {
                  dbName: 'database',
                  path: 'userInfo',
                  defaultValue: {}
              }, { root: true });
                if (userInfo.mobile) {
                  state.history = oldInfo[userInfo.mobile] || []
                } else {
                  state.history = oldInfo.all || []
                }
                // end
                resolve();
            })
        },
        /**
           * @description 设置搜索记录
           * @param {Object} state vuex state
           * @param {Object} dispatch vuex dispatch
           * @param {*} info info
           */
          setKeyword ({ state, dispatch }, info) {
            return new Promise(async resolve => {
                // store 赋值
                state.keyword = info;
                let oldInfo = await dispatch('db/get', {
                  dbName: 'database',
                  path: 'guideKeyword',
                  defaultValue: {}
              }, { root: true });
              let userInfo = await dispatch('db/get', {
                  dbName: 'database',
                  path: 'userInfo',
                  defaultValue: {}
              }, { root: true });
              if (userInfo.mobile) {
                  oldInfo[userInfo.mobile] = info
              } else {
                  oldInfo.all = info
              }
                // 持久化
                await dispatch('db/set', {
                    dbName: 'database',
                    path: 'guideKeyword',
                    value: oldInfo
                }, { root: true });
                // end
                resolve();
            })
        },

        /**
         * @description 从数据库取搜索记录
         * @param {Object} state vuex state
         * @param {Object} dispatch vuex dispatch
         */
        loadKeyword ({ state, dispatch }) {
            return new Promise(async resolve => {
                // store 赋值
                let oldInfo = await dispatch('db/get', {
                  dbName: 'database',
                  path: 'guideKeyword',
                  defaultValue: {}
              }, { root: true });
              console.log(oldInfo)
              let userInfo = await dispatch('db/get', {
                  dbName: 'database',
                  path: 'userInfo',
                  defaultValue: {}
              }, { root: true });
              if (userInfo.mobile) {
                state.keyword = oldInfo[userInfo.mobile] || []
              } else {
                state.keyword = oldInfo.all || []
              }
              console.log(state.keyword)
                // end
                resolve(state.keyword);
            })
        },
        setUser ({ state, dispatch }, info) {
          return new Promise(async resolve => {
              // store 赋值
            state.userInfo = info
            // 持久化
            await dispatch('db/set', {
              dbName: 'database',
              path: 'userInfo',
              value: info
          }, { root: true });
              // end
              resolve();
          })
        },
        loadUser ({ state, dispatch }) {
          return new Promise(async resolve => {
              // store 赋值
              state.userInfo = await dispatch('db/get', {
                dbName: 'database',
                path: 'userInfo',
                defaultValue: {}
            }, { root: true });
              // end
              resolve(state.userInfo);
          })
      }
    }
  }
